import { COLUMN_TYPES } from '../../../data-table/DataTableColumns';
import { filterId as testFilterId } from '../../../filters/test-filter/TestFilter';
import WirelessInterfaceIcon from '../WirelessInterfaceIcon';

export function isShowWireless(testType) {
    const supportsInterfaceSelection = testType?.supportsInterfaceSelection || false;
    const isWiFiTest = testType?.name === 'wifi';
    const isVoipTest = testType?.group === 'VoIP';
    const isWifiConnectTest = testType?.group === 'wifiConnect';
    const isWifiGroupTest = testType?.group === 'wifiConnectMultiTest';
    return supportsInterfaceSelection || isWiFiTest || isVoipTest || isWifiConnectTest || isWifiGroupTest;
}

export function getWirelessInterfaceColumn(filterState) {
    const test = filterState?.current?.[testFilterId];
    const testType = test?.typeNode;

    // Do not show the column if this is not a supported test
    const showColumn = isShowWireless(testType);

    return showColumn
        ? [
              {
                  type: COLUMN_TYPES.ICON,
                  width: 24,
                  uiOnly: true,
                  icons: [
                      {
                          getIcon: (row) => {
                              return row.adapter_type === 'wireless' ? <WirelessInterfaceIcon row={row} /> : null;
                          },
                      },
                  ],
              },
          ]
        : [];
}
